import React from 'react';
import Helmet from 'react-helmet';

import HeaderDefault from '../../../components/global/HeaderDefault';
import Footer from '../../../components/global/Footer';
import WebGalleryDiscoveryContainer from '../containers/WebGalleryDiscoveryContainer';
import ContentWrap from '../../../components/global/ContentWrap';
import { getAsset } from '../../../util/assets';
import WaldoProductLogo from '../../../components/global/WaldoProductLogo';
import WebGalleryAdWidgetDiscoveryModalContainer from '../containers/WebGalleryAdWidgetDiscoveryModalContainer';
import getConfig from '../../../util/config';

const WebGalleriesDiscoveryView = () => {
  const { marcomUrl } = getConfig();

  return (
    <div className="wrapper-main">
      <Helmet>
        <title>Welcome to Waldo Galleries &ndash; Waldo</title>
      </Helmet>

      <HeaderDefault />

      <div className="content-wrap content-wrap-gray flex-column justify-content-center">
        <ContentWrap size="lg" mainClassName="p-0">
          <div className="row no-gutters">
            <div className="col-lg-5 col-12 bg-gray bg-waldo-pattern">
              <div className="d-flex flex-column align-items-center justify-content-center p-lg-6 my-lg-6 my-2">
                <p className="text-faded m-0">Welcome to</p>
                <WaldoProductLogo type="photos" size="lg" />
                <img
                  src={getAsset('/illustration-waldo-albums.png')}
                  alt=""
                  width="100"
                  className="mt-4 d-md-block d-none"
                />
              </div>
            </div>
            <div className="col-lg-7 col-12 flex-auto d-flex justify-content-center flex-column">
              <div className="p-lg-5 p-3 d-flex align-items-center justify-content-center">
                <WebGalleryDiscoveryContainer />
              </div>
            </div>
          </div>
        </ContentWrap>

        <div className="text-center text-sm">
          <a
            href={`${marcomUrl}/refer-waldo`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Bring Waldo
          </a>{' '}
          to your school, camp or youth sports league.
        </div>
      </div>
      <Footer />

      <WebGalleryAdWidgetDiscoveryModalContainer />

      <img
        // Tracker "pixel" used for re-marketing
        src="https://tags.w55c.net/rs?id=4fc095a2fa624540b2add104addd4bc2&t=homepage"
        style={{ display: 'none' }}
        alt=""
      />
    </div>
  );
};

export default WebGalleriesDiscoveryView;
